/* eslint-disable no-unused-vars */
import React from "react";
/* eslint-enable no-unused-vars */
import { createSvgIcon } from "utils";

export default createSvgIcon(
  <React.Fragment>
    <path d="M2 3h9v9H2V3m9 19H2v-9h9v9M21 3v9h-9V3h9m0 19h-9v-9h9v9z" />
  </React.Fragment>,
  "Microsoft",
  {
    viewBox: "0 0 24 24",
  }
);
